import { Decoration } from '@tiptap/pm/view';

import type { ModalService } from './../../../ricos-modals';
import type { Layout, Placement, RicosServices, TextDirection, TiptapEditor } from './../../../ricos-types';
import { PLUGIN_MENU_HORIZONTAL_MODAL_ID } from './../../../ricos-types';

import { TABLE_PLUS_BUTTON } from '../../data-hooks';
import styles from '../../statics/styles/side-toolbar-scss';
import { supportedPluginTypes } from '../consts';
import { getPluginMenuIcon } from './svgs';

const BUTTON_ID = 'table-plugin-menu-button-id';

export const pluginMenuDecoration = ($cell: any, editor: TiptapEditor, services: RicosServices) => {
  const {
    modals: modalService,
    context: { languageDir },
    getEditorQuery,
    t,
  } = services;

  const plusButton = document.createElement('button');
  plusButton.setAttribute('data-hook', TABLE_PLUS_BUTTON);
  plusButton.setAttribute('type', 'button');

  plusButton.addEventListener('click', () =>
    handlePlusButtonClick(modalService, plusButton, languageDir)
  );

  plusButton.addEventListener('mousedown', () => {
    if (editor.isFocused) {
      setTimeout(() => {
        document.getElementById(BUTTON_ID)?.click();
      }, 0);
    }
  });

  const { selection } = editor.state;

  const nodeAtPos = editor.state.doc.nodeAt($cell.pos);
  const { isChildSingleTextBlock } = getEditorQuery?.().query || {};
  plusButton.innerHTML = getPluginMenuIcon(t('TablePlugin_PluginMenu_Tooltip'));
  plusButton.classList.add(styles.sideToolbar_floatingIcon);
  plusButton.classList.add(styles[languageDir]);
  plusButton.style.visibility = isChildSingleTextBlock?.(nodeAtPos?.attrs.id)
    ? 'visible'
    : 'hidden';
  plusButton.id = BUTTON_ID;

  // this should mitigate the issue where text selection doesn't work properly
  // when the cursor is at the end of line which is not empty
  const resolvePosition = (pos: number) => {
    const current = editor.state.doc.nodeAt(pos);
    const previous = editor.state.doc.nodeAt(pos - 1);
    const next = editor.state.doc.nodeAt(pos + 1);

    const isEndOfLine = !current && !next && previous?.type.name === 'text';

    if (isEndOfLine) {
      return pos - 1;
    }

    return pos;
  };

  const resolved = resolvePosition(selection.from);

  return Decoration.widget(resolved, plusButton);
};

function handlePlusButtonClick(
  modalService: ModalService,
  plusButton: HTMLButtonElement,
  languageDir: TextDirection
) {
  const layout: Layout = 'toolbar';
  const placement: Placement = languageDir === 'ltr' ? 'right-start' : 'left-start';

  if (modalService.isModalOpen(PLUGIN_MENU_HORIZONTAL_MODAL_ID)) {
    modalService.closeModal(PLUGIN_MENU_HORIZONTAL_MODAL_ID);
    plusButton.classList.remove(styles.sideToolbar_popupOpen);
  } else {
    modalService.openRegisteredModal(PLUGIN_MENU_HORIZONTAL_MODAL_ID, {
      positioning: { referenceElement: plusButton?.parentElement, placement },
      layout,
      componentProps: {
        referenceElement: { current: plusButton?.parentElement },
        supportedButtonIds: supportedPluginTypes,
      },
    });
    plusButton.classList.add(styles.sideToolbar_popupOpen);
  }
}
